// extracted by mini-css-extract-plugin
export default {"workflowStatistics":"WorkflowStatistics_workflowStatistics__ej+VP"};